export const tabNames = {
    search: 'Search for document',
    upload: 'Upload document',
    url: 'Enter URL of document',
}

export const isBuild = process.env.REACT_APP_BLD === 'build' ? true : false
export const isMobile = navigator.userAgent.match(/mobile/im) ? true : false